export const CURSOR = {
    EDITING_TEXT: {
        START: 'CURSOR.EDITING_TEXT.START',
        END: 'CURSOR.EDITING_TEXT.END',
        END_NO_SAVE: 'CURSOR.EDITING_TEXT.END_NO_SAVE'
    },
    UPDATE_ORIGINAL_TEXT: 'CURSOR.UPDATE_ORIGINAL_TEXT',
    DELETE_NODE: 'CURSOR.DELETE_NODE',
    MOVE_CURSOR_TO: 'CURSOR.MOVE_CURSOR_TO',
    MOVE_CURSOR_TO_BEST_CHILD_OR_SELF: 'CURSOR.MOVE_CURSOR_TO_BEST_CHILD_OR_SELF'
}

export const NODE = {
    POST: {
        REQUEST: 'NODE.POST.REQUEST'
    },
    PATCH_LOCATION: {
        REQUEST: 'NODE.PATCH_LOCATION.REQUEST'
    },
    PATCH_CONTENT: {
        REQUEST: 'NODE.PATCH_CONTENT.REQUEST'
    },
    DELETE: {
        REQUEST: 'NODE.DELETE.REQUEST'
    },
    TOGGLE: 'NODE.TOGGLE',
    BATCH_UPDATE: 'NODE.BATCH_UPDATE'
}

export const SYNC = {
    UPDATE_TREE_SYNC_STATUS: 'SYNC.UPDATE_TREE_SYNC_STATUS',
    UPDATE_SYNC_HASH: 'SYNC.UPDATE_SYNC_HASH',
    UPDATE_LAST_SERVER_COMMUNICATION_TIME: 'SYNC.UPDATE_LAST_SERVER_COMMUNICATION_TIME',
    UPDATE_LAST_NETWORK_REQUEST_WAS_OFFLINE: 'SYNC.UPDATE_LAST_NETWORK_REQUEST_WAS_OFFLINE',
    UPDATE_EXPORT_START_TIME: 'SYNC.UPDATE_EXPORT_START_TIME'
}

export const USER = {
    LOGIN: {
        SUCCESS: 'USER.LOGIN.SUCCESS'
    },
    LOGOUT: 'USER.LOGOUT',
    GET: {
        REQUEST: 'USER.GET.REQUEST',
        SUCCESS: 'USER.GET.SUCCESS'
    }
}
